module.exports = {"top3":["Adults who are obese","Preventable hospitalizations ages 18-64","Hospitals with lower-than-average patient experience ratings"],"bottom3":["High out-of-pocket medical spending","Suicide deaths","Alcohol deaths"],"most_improved":["Uninsured children","Home health patients without improved mobility","Diabetic adults without an annual hemoglobin A1c test"],"most_declined":["Hospital 30-day readmission rate ages 18-64","Hospital 30-day mortality","Preventable hospitalizations ages 18-64"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/CO.json
// module id = 245
// module chunks = 143196823979170 184088790168614